import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUnlocked2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="unlocked-2, unlock, private"><path d="M4.75 14.5C4.75 10.634 8.13401 7.25 12 7.25C15.866 7.25 19.25 10.634 19.25 14.5C19.25 18.366 15.866 21.75 12 21.75C8.13401 21.75 4.75 18.366 4.75 14.5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12 11.75V16.75" stroke="currentColor" strokeWidth="1.5"/><path d="M8 8.5V6.25C8 4.04086 9.79086 2.25 12 2.25C13.7726 2.25 15.2759 3.40303 15.8008 5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconUnlocked2;
